"use strict";
exports.__esModule = true;
exports.SvgUpload = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgUpload = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M19.25 20.5a.75.75 0 010 1.5H4.75a.75.75 0 010-1.5h14.5zM11.554 2.147a.748.748 0 01.976.073l5.001 5 .073.085a.748.748 0 01-.073.976l-.084.073a.748.748 0 01-.976-.073L12.75 4.563v12.438l-.007.102a.75.75 0 01-1.493-.102V4.563L7.53 8.281l-.084.073a.748.748 0 01-.976-1.133l5-5.001z" }),
        react_1["default"].createElement("path", { d: "M0 0h24v24H0z" })))); };
//# sourceMappingURL=Upload.js.map